import API from 'services/api';

import { IICalAdd } from '../models';

export const postImportICalLite = ({ unitId, payload }: { unitId: string; payload: IICalAdd }) =>
  API.post(`/api/renter/accommodation/properties/iCal/units/${unitId}`, payload);
